let API_URL = "https://streammydata.ru/wp-json/applications/v1"

if (!process.env.NODE_ENV || process.env.NODE_ENV === 'development') {
    API_URL = "https://smd.medianation.dev/wp-json/applications/v1"
} 

const ENDPOINTS = {
    SEND_USER_DATA: "/application"
}

const TOKEN = "a29a84896f81c3a2736b113e57357714";
export const sendUserData = async (userData) => {
    const body = JSON.stringify({ name: userData.name, phone: userData.phone.phone, question: userData.question });
    const path = `${API_URL}${ENDPOINTS.SEND_USER_DATA}`
    try {
        return fetch(path, {
            method: "POST",
            body,
            headers: {
                'Content-Type': 'application/json',
                Authorization: TOKEN
            }
        }).then(response => {
            if (!response.ok) {
                throw new Error("Network error")
            }
        })
    } catch (e) {
        throw new Error(e.message);
    }
}